<h1 dialog-title> <b>Validar Préstamo </b></h1> <br/>

<form #prestamoValidaForm=ngForm>
    <mat-dialog-content>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Solicitante </label>
                <br/> {{data.nombreUsuario}} {{data.apellidoUsuario}} ({{data.rutUsuario}})

            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">

                <label>Tipo de Préstamo </label><br/>

                <select name="tipoPrestamo" id="tipoPrestamo" #tipoPrestamo="ngModel" [(ngModel)]="prestamo.tipoPrestamo" [disabled]="data.deshabilitado" required>

                <option *ngFor="let tipo of this.data.tipos" value="{{tipo.id}}">

                    {{tipo.descripcion}}

                </option>
            </select>

            </form-field>
        </p>

        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Monto Solicitado </label><br/>
                <input matInput type="number" value="prestamo.montoSolicitado" id="montoSolicitado" name="montoSolicitado" [(ngModel)]="prestamo.montoSolicitado" #montoSolicitado="ngModel" placeholder="Monto Máximo Disponible" max="prestamo.totalMaximo" [disabled]="data.deshabilitado"
                    required>
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">

                <label>Cantidad Cuotas </label><br/>

                <select name="cantidadCuotas" id="cantidadCuotas" #cantidadCuotas="ngModel" [(ngModel)]="prestamo.cantidadCuotas" required [disabled]="data.deshabilitado">

                <option *ngFor="let cuota of this.data.cuotas" value="{{cuota.id}}">

                    {{cuota.descripcion}}

                </option>
            </select>

            </form-field>
        </p>

        <p>
            <button class="btn btn-primary" id="btnCalcularPlanPago" name="btnCalcularPlanPago" (click)="calcularPlanPago()" [disabled]="data.deshabilitado">
                Calcular
        </button>
            <label>Si cambia el monto solicitado o la cantidad de cuotas, debe presionar el botón para actualizar el plan de pago</label>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Monto Cuota a Pagar </label>
                <br/>&emsp;{{data.montoTotalCuota}}
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label> Fecha Primer Descuento</label>
                <br/>&emsp;{{data.fechaPrimerPago}}
            </form-field>
        </p>
        <p>
            <form-field appearance="outline" class="mat-input">
                <label>Codeudores </label>
                <br/>
                <label>&emsp;{{data.nombreCodeudor1}} {{data.apellidoCodeudor1}} ({{data.rutCodeudor1}})</label> <br/>
                <label>&emsp;{{data.nombreCodeudor2}} {{data.apellidoCodeudor2}} ({{data.rutCodeudor2}}) </label>

            </form-field>
        </p>
        <p>
            <button class="mat-raised-button btn-info" (click)="onDescargarArchivosClick(data.idPostulacion)">
        
                <i class = "fa fa-download"> </i> Ver Archivo(s) Ingresado(s)</button>
        </p>

    </mat-dialog-content>
</form>
<br/>

<mat-dialog-actions>
   
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-warning" (click)="onEditarPostulacionClick()"> 
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago && data.mostrarAprobarButton " mat-button class="mat-raised-button btn-success" (click)="onAprobarPostulacionClick(data.idPostulacion)">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-danger" (click)="onRechazarPostulacionClick(data.idPostulacion)">
            <i class = "fa fa-times"> </i> Rechazar
        </button>
        <button style="width: 100px" mat-button class="mat-raised-button btn-danger" *ngIf="(data.rol =='ROLE_ADMINISTRADOR') && !data.presionaEditar && data.disponiblePago && data.mostrarAprobarButton &&  ((data.estado == 'APROBADA') || (data.estado == 'EN VALIDACION') || (data.estado == 'DISPONIBLE PARA PAGO'))" (click)="openDialogAnular(data.idPostulacion, data.rutUsuario)"> <!--*ngIf="pre.estado == 'INGRESADA' "-->

            <i class = "fa fa-trash"> </i> Anular

        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(prestamoValidaForm)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>
    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>
<br/>